import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CountriesQueryObject {
  countries: {
    id: boolean
    full_name_locale: boolean
  }
}

export const countriesQueryObject: CountriesQueryObject = {
  countries: {
    id: true,
    full_name_locale: true
  }
}

export type CountriesQuery = () => Promise<ApolloQueryResult<any>>

export const createCountriesQuery = ({ getQueries }: ServiceDependencies): CountriesQuery => async () => {
  const query = getQueries().countriesQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`
  })
}
